import { style } from '@vanilla-extract/css'

export const note = style({
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  color: '#828282',
})

export const noteIcon = style({
  paddingTop: '4px',
})

export const card = style({
  borderRadius: '16px',
  padding: '16px',
  backgroundColor: 'white',
  boxShadow: '0px 8px 16px 0px #C5C5C50D',
  width: '100%',
})

export const cardHeading = style({
  fontSize: '15px',
  fontWeight: '700',
  textWrap: 'pretty',
})

export const goodiesThumbnail = style({
  width: '84px',
  height: '84px',
  borderRadius: '8px',
  objectFit: 'cover',
})

export const goodiesName = style({
  fontSize: '12px',
})

export const goodiesPrice = style({
  fontSize: '12px',
  fontWeight: '700',
})

export const cancelButton = style({
  fontSize: '13px',
  fontWeight: '700',
  textDecoration: 'underline',
  selectors: {
    '&:disabled': {
      opacity: 0.5,
      cursor: 'default',
    },
  },
})
